import benefits_data_source_url_sm from "@/assets/images/home/benefits/data-source-sm.png";
import benefits_data_source_thumbnail_url_sm from "@/assets/images/home/benefits/data-source-sm_thumbnail.png";
import insight_url_sm from "@/assets/images/home/benefits/insight-sm.png";
import insight_thumbnail_url_sm from "@/assets/images/home/benefits/insight-sm_thumbnail.png";
import real_time_data_url_sm from "@/assets/images/home/benefits/real-time-data-sm.png";
import real_time_data_thumbnail_url_sm from "@/assets/images/home/benefits/real-time-data-sm_thumbnail.png";
import trackmate_platform_url_sm from "@/assets/images/home/benefits/trackmate-platform-sm.png";
import trackmate_platform_thumbnail_url_sm from "@/assets/images/home/benefits/trackmate-platform-sm_thumbnail.png";

import benefits_data_source_url_lg from "@/assets/images/home/benefits/data-source-lg.png";
import benefits_data_source_thumbnail_url_lg from "@/assets/images/home/benefits/data-source-lg_thumbnail.png";
import insight_url_lg from "@/assets/images/home/benefits/insight-lg.png";
import insight_thumbnail_url_lg from "@/assets/images/home/benefits/insight-lg_thumbnail.png";
import real_time_data_url_lg from "@/assets/images/home/benefits/real-time-data-lg.png";
import real_time_data_thumbnail_url_lg from "@/assets/images/home/benefits/real-time-data-lg_thumbnail.png";
import trackmate_platform_url_lg from "@/assets/images/home/benefits/trackmate-platform-lg.png";
import trackmate_platform_thumbnail_url_lg from "@/assets/images/home/benefits/trackmate-platform-lg_thumbnail.png";

import clock_icon_url from "@/assets/icons/home/benefits/clock.svg?react";
import desktop_icon_url from "@/assets/icons/home/benefits/desktop.svg?react";
import eye_icon_url from "@/assets/icons/home/benefits/eye.svg?react";
import stack_icon_url from "@/assets/icons/home/benefits/stack.svg?react";

export const getBenefits = (isMobile: boolean) => [
  {
    title: "Multiple Data Points",
    description: "Connect all the things that matter.",
    imageUrl: isMobile
      ? benefits_data_source_url_sm
      : benefits_data_source_url_lg,
    thumbnail: isMobile
      ? benefits_data_source_thumbnail_url_sm
      : benefits_data_source_thumbnail_url_lg,
    Icon: stack_icon_url,
    maxWidth: 556,
  },
  {
    title: "Real-Time Insights",
    description:
      "Access up-to-the-minute data on all your connected assets to enable sound decision-making and seamless management.",
    imageUrl: isMobile ? real_time_data_url_sm : real_time_data_url_lg,
    thumbnail: isMobile
      ? real_time_data_thumbnail_url_sm
      : real_time_data_thumbnail_url_lg,
    Icon: clock_icon_url,
    maxWidth: 439,
  },
  {
    title: "The Trackmate GPS Platform",
    description:
      "Trackmate is an all-in-one GPS tracking and asset management solution with a robust feature set designed for peace of mind.",
    imageUrl: isMobile ? trackmate_platform_url_sm : trackmate_platform_url_lg,
    thumbnail: isMobile
      ? trackmate_platform_thumbnail_url_sm
      : trackmate_platform_thumbnail_url_lg,
    Icon: desktop_icon_url,
    maxWidth: 432,
  },
  {
    title: "Exceptional Visibility",
    description:
      "Gain full transparency into your fleet, cargo, and conditions to improve service quality, reduce costs, and optimize bottom-line benefits.",
    imageUrl: isMobile ? insight_url_sm : insight_url_lg,
    thumbnail: isMobile ? insight_thumbnail_url_sm : insight_thumbnail_url_lg,
    Icon: eye_icon_url,
    maxWidth: 469,
  },
];
